import { render, staticRenderFns } from "./ProjectAvatar.vue?vue&type=template&id=ff8ef8fc&scoped=true"
import script from "./ProjectAvatar.vue?vue&type=script&lang=js"
export * from "./ProjectAvatar.vue?vue&type=script&lang=js"
import style0 from "./ProjectAvatar.vue?vue&type=style&index=0&id=ff8ef8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8ef8fc",
  null
  
)

export default component.exports